<svg
  aria-labelledby="title description"
  class="w-full h-auto fill-inherit"
  width='100%'
  viewBox="0 0 32 32"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <title>Email icon</title>
  <path fill="currentColor" d="M31.3937 11.925C31.6375 11.7313 32 11.9125 32 12.2188V25C32 26.6562 30.6562 28 29 28H3C1.34375 28 0 26.6562 0 25V12.225C0 11.9125 0.35625 11.7375 0.60625 11.9312C2.00625 13.0187 3.8625 14.4 10.2375 19.0312C11.5563 19.9937 13.7812 22.0188 16 22.0063C18.2313 22.025 20.5 19.9563 21.7687 19.0312C28.1437 14.4 29.9937 13.0125 31.3937 11.925ZM16 20C17.45 20.025 19.5375 18.175 20.5875 17.4125C28.8812 11.3938 29.5125 10.8687 31.425 9.36875C31.7875 9.0875 32 8.65 32 8.1875V7C32 5.34375 30.6562 4 29 4H3C1.34375 4 0 5.34375 0 7V8.1875C0 8.65 0.2125 9.08125 0.575 9.36875C2.4875 10.8625 3.11875 11.3938 11.4125 17.4125C12.4625 18.175 14.55 20.025 16 20Z" />
</svg>
